import React, { useState } from "react";

export default function SupplierCardLite(props) {
  const [toggleExpand, setToggleExpand] = useState(false);

  const getActiveFamilyIcon = (id) => {
    const iconObj = {
      0: "/images/preferenciaAudifonos.svg",
      1: "/images/preferenciaGafasGraduadas.svg",
      2: "/images/preferenciaLentillas.svg",
      3: "/images/preferenciaLiquido.svg",
      4: "/images/accommodative-blue.svg",
      5: "/images/preferenciaVarios.svg",
      6: "/images/preferenciaGafasDeSol.svg",
    };
    return iconObj[id] || "";
  };

  return (
    <div className="supplier-card-info">
      <div className="supplier-card">
        <button className="popup-action-icon close-icon">
          <img
            src="/images/close-dark-blue.svg"
            loading="lazy"
            alt="Icon"
            onClick={() => {
              props.onClose();
            }}
          ></img>
        </button>
        <span className="section-content-title">{props.supplier.nombre}</span>
        <div className="section-content-sep"></div>
        <div className="section-content-data store-content-data">
          <div>
            <div className="data-field-row">
              <div className="data-field d-medium">
                <span className="label">Código:</span>
                <span>{props.supplier.codigo}</span>
              </div>
            </div>
            <div className="data-field-row">
              <div className="data-field d-medium">
                <span className="label">Teléfono:</span>
                <span>{props.supplier.telefono}</span>
              </div>
            </div>
          </div>
          <div>
            <div className="data-field-row">
              <div className="data-field d-medium">
                <span className="label">Email:</span>
                <span>{props.supplier.email}</span>
              </div>
            </div>
            <div className="data-field-row">
              <div className="data-field d-medium">
                <span className="label">Contacto:</span>
                <span>{props.supplier.contacto}</span>
              </div>
            </div>
          </div>
        </div>
        {toggleExpand && (
          <div className="section-content-data store-content-data">
            <div>
              <div className="data-field-row">
                <div className="data-field d-medium">
                  <span className="label">Dirección:</span>
                  <span>{props.supplier.direccion}</span>
                </div>
              </div>
              <div className="data-field-row">
                <div className="data-field d-medium">
                  <span className="label">Nombre:</span>
                  <span>{props.supplier.nombre}</span>
                </div>
              </div>
            </div>
            <div>
              <div className="data-field-row">
                <div className="data-field d-medium">
                  <span className="label">Localidad:</span>
                  <span>{props.supplier.localidad}</span>
                </div>
              </div>
              <div className="data-field-row">
                <div className="data-field d-medium">
                  <span className="label">NIF:</span>
                  <span>{props.supplier.nif}</span>
                </div>
              </div>
            </div>
            <div>
              <div className="data-field-row">
                <div className="data-field d-medium">
                  <span className="label">C.P.:</span>
                  <span>{props.supplier.cp}</span>
                </div>
              </div>
            </div>
          </div>
        )}
        {toggleExpand && (
          <div className="section-content-data store-content-data">
            <div>
              <div className="data-field-row">
                <div className="data-field d-medium">
                  <span className="label">
                    Familias activas ({props.supplier.familiasActivas.length}
                    ):&nbsp;
                    {props.supplier.familiasActivas.map((id, index) => {
                      return (
                        <img
                          src={getActiveFamilyIcon(id)}
                          loading="lazy"
                          alt="icon"
                          style={{ width: "12px", marginRight: 5 }}
                          key={index}
                        />
                      );
                    })}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
        <button
          style={{
            position: "absolute",
            bottom: 5,
            right: 10,
            fontSize: 13,
            fontWeight: 500,
            color: "#afafaf",
          }}
          onClick={() => {
            setToggleExpand(!toggleExpand);
          }}
        >
          {!toggleExpand ? "Más" : "Menos"}
        </button>
      </div>
    </div>
  );
}
